enum I18nLanguageEnum {
  English = 'en',
  'Tiếng Việt' = 'vi',
  'ភាសាខ្មែរ' = 'km',
}

export { I18nLanguageEnum };
